// src/pages/paidProject/Annexure 1/FinanceCharges.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../../../api";

export default function FinanceCharges() {
  const { projectId } = useParams();
  const [summary, setSummary] = useState([]);

  // Helper: same month-label logic as TermLoanRepayment
  const generateMonthLabels = (startStr, length) => {
    if (!startStr || !startStr.includes("-")) return [];
    const [startM, startY] = startStr.split("-").map(Number);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let m = startM - 1,
      y = startY;
    return Array.from({ length }, () => {
      const label = `${months[m]}-${y}`;
      m = (m + 1) % 12;
      if (m === 0) y++;
      return label;
    });
  };

  useEffect(() => {
    API.get(`/user/project-inputs/${projectId}`)
      .then(({ data }) => {
        const term = data.termLoanInput || {};
        let emiSchedule = Array.isArray(term.emiSchedule)
          ? term.emiSchedule
          : [];

        /* // fallback to localStorage if server has none
        if (!emiSchedule.length) {
          const local = JSON.parse(localStorage.getItem('emiSchedule') || '[]');
          if (Array.isArray(local) && local.length) {
            emiSchedule = local;
          }
        } */

        // pick start-month (pStart or fallback start)
        const rawStart =
          term.pStartMonth && term.pStartMonth.includes("-")
            ? term.pStartMonth
            : term.startMonth || "";

        if (!emiSchedule.length) {
          setSummary([]);
          return;
        }

        const monthLabels = generateMonthLabels(rawStart, emiSchedule.length);
        const monthsMap = {
          Jan: 1,
          Feb: 2,
          Mar: 3,
          Apr: 4,
          May: 5,
          Jun: 6,
          Jul: 7,
          Aug: 8,
          Sep: 9,
          Oct: 10,
          Nov: 11,
          Dec: 12,
        };
        const bucket = {};
        emiSchedule.forEach((row, idx) => {
          const lbl = monthLabels[idx] || "";
          const [monStr, yrStr] = lbl.split("-");
          const mon = monthsMap[monStr] || 0;
          const yr = parseInt(yrStr, 10) || 0;
          const fyStart = mon >= 4 ? yr : yr - 1;
          const fyLabel = `${fyStart}-${String(fyStart + 1).slice(-2)}`;

          if (!bucket[fyLabel]) {
            bucket[fyLabel] = {
              year: fyLabel,
              totalPrincipal: 0,
              totalInterest: 0,
              closingBalance: 0,
            };
          }
          bucket[fyLabel].totalPrincipal += row.principal;
          bucket[fyLabel].totalInterest += row.interest;
          bucket[fyLabel].closingBalance = row.closingBalance;
        });

        setSummary(Object.values(bucket));
      })
      .catch((err) => {
        console.error("Failed to load Finance Charges data", err);
        setSummary([]);
      });
  }, [projectId]);

  const fmt = (n) =>
    isNaN(n)
      ? "-"
      : Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 });

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Finance Charges Summary</h1>

      {summary.length === 0 ? (
        <p className="text-red-600">
          No EMI schedule found. Please complete the term loan repayment first.
        </p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-4 py-2 border text-left">Financial Year</th>
                <th className="px-4 py-2 border text-right">
                  Total Principal (Rs)
                </th>
                <th className="px-4 py-2 border text-right">
                  Total Interest (Rs)
                </th>
                <th className="px-4 py-2 border text-right">
                  Closing Balance (Rs)
                </th>
              </tr>
            </thead>
            <tbody>
              {summary.map((item) => (
                <tr key={item.year} className="odd:bg-white even:bg-gray-50">
                  <td className="px-4 py-2 border">{item.year}</td>
                  <td className="px-4 py-2 border text-right">
                    {fmt(item.totalPrincipal)}
                  </td>
                  <td className="px-4 py-2 border text-right">
                    {fmt(item.totalInterest)}
                  </td>
                  <td className="px-4 py-2 border text-right">
                    {fmt(item.closingBalance)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
